import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import FormattedText from '../../../01_atoms/FormattedText';
import Button from '../../../01_atoms/Button';

/* global Cookiebot */
const withCookieConsentPopupFeed = (Content) => {
  class FeedWithCookieConsent extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        isCookiebotLoaded: false,
        isComponentVisible: false,
      };

      this.onCookiebotLoad = this.onCookiebotLoad.bind(this);
      this.onAcceptCookie = this.onAcceptCookie.bind(this);
    }

    componentDidMount() {
      const { cookieConsentType } = this.props;
      if (cookieConsentType) {
        window.addEventListener('CookiebotOnConsentReady', this.onCookiebotLoad);
      }

      // In case when Cookiebot already loaded we need to switch component to
      // the right state. For example when we open popup with embedded video.
      if (typeof Cookiebot !== 'undefined') {
        this.onCookiebotLoad();
      }
    }

    componentWillUnmount() {
      const { cookieConsentType } = this.props;
      if (cookieConsentType) {
        window.removeEventListener('CookiebotOnConsentReady', this.onCookiebotLoad);
      }
    }

    onCookiebotLoad() {
      const { cookieConsentType } = this.props;

      if (Cookiebot && Cookiebot.consent && Cookiebot.consent[cookieConsentType]) {
        this.setState({
          isCookiebotLoaded: true,
          isComponentVisible: true,
        });
      } else {
        this.setState({
          isCookiebotLoaded: true,
          isComponentVisible: false,
        });
      }
    }

    onAcceptCookie(preferences, statistics, marketing) {
      const { isExample } = this.props;
      if (isExample) {
        this.setState({ isCookiebotLoaded: true, isComponentVisible: true });
      } else {
        Cookiebot.submitCustomConsent(preferences, statistics, marketing);
      }
    }

    render() {
      const { isExample, cookieConsentType, cookieDialogHeading, cookieDialogDescription } =
        this.props;
      const { isCookiebotLoaded, isComponentVisible } = this.state;

      // We expect that cookieConsentType will be always defined. Otherwise
      // we think that component doesn't expect certain level of cookies, so
      // we can render component as is.
      // Outer div is needed to keep the same markup for all cases, otherwise
      // the component will be rerendered which causes double widget initialization.
      if (!cookieConsentType && !isExample) {
        return (
          <div>
            <Content {...this.props} />
          </div>
        );
      }

      let preferences;
      let statistics;
      let marketing;

      if (isCookiebotLoaded || isExample) {
        if (isComponentVisible) {
          return (
            <div>
              <Content {...this.props} />
            </div>
          );
        }

        if (!isExample) {
          preferences = cookieConsentType === 'preferences';
          statistics = cookieConsentType === 'statistics';
          marketing = cookieConsentType === 'marketing';

          if (Cookiebot && Cookiebot.consent) {
            preferences = preferences || Cookiebot.consent.preferences;
            statistics = statistics || Cookiebot.consent.statistics;
            marketing = marketing || Cookiebot.consent.marketing;
          }
        }
      }

      const title =
        cookieDialogHeading || `Please accept ${cookieConsentType} cookies to view this content.`;

      return (
        <div className={styles['bb-raw-html']}>
          <div className={styles['bb-raw-html-with-cookie']}>
            {!isComponentVisible && (
              <div>
                <div className={styles['bb-raw-html-dialog-desktop']}>
                  <div>
                    <div className={styles['bb-raw-html-dialog-desktop-header']}>
                      <h4 className={styles['bb-raw-html-dialog-desktop-header-title']}>{title}</h4>
                    </div>
                    {cookieDialogDescription && (
                      <FormattedText
                        className={styles['bb-raw-html-dialog-desktop-description']}
                        text={cookieDialogDescription}
                      />
                    )}
                  </div>
                  <div className={styles['bb-raw-html-dialog-desktop-buttons']}>
                    <Button
                      className="allow-cookies-raw-html-bb"
                      type="secondary"
                      onClick={() => this.onAcceptCookie(preferences, statistics, marketing)}
                    >
                      Allow cookies
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
  }

  FeedWithCookieConsent.propTypes = {
    // isExample param can be used in case when we have to gain
    // the same behaviour of the component without Cookiebot.
    // Already used on the Body Blocks page in styleguide.
    isExample: PropTypes.bool,
    cookieConsentType: PropTypes.string,
    cookieDialogHeading: PropTypes.string,
    cookieDialogDescription: PropTypes.string,
  };

  FeedWithCookieConsent.defaultProps = {
    isExample: false,
    cookieConsentType: '',
    cookieDialogHeading: '',
    cookieDialogDescription: '',
  };

  return FeedWithCookieConsent;
};

export default withCookieConsentPopupFeed;
